export default "__VITE_ASSET__Bz0MDGc4__"